import React from "react";
import Applet from "../../Applet";
import ETLJobTable from "../../../../components/ETLJob/ETLJobTable";

class ETLJobTableApplet extends Applet {

    render() {
        return <ETLJobTable applet={this}
                                       pageSize={this.state.PageSize}
                                       placement={this.state.Placement}
                                       columns={this.state.Columns}
                                       title="Jobs"
                                       enterpriseComponent={this.getEnterpriseComponent()}
                                       sort={this.state.Sort}
                                       menu={this.state.Menu}
                                       rowHeight={this.state.RowHeight}
        />;
    }

    state = {
        Name: "ETLJobTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "New Job",
                    value: "New Job",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 40,
            "xs": 3,
            "sm": 3,
            "md": 40,
            "lg": 40,
            "lx": 40,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "Name",
                },
                {
                    id: "OwnerName",
                },
                {
                    id: "Type",
                },
                {
                    id: "SubType",
                },
                {
                    id: "Status",
                },
                {
                    id: "NumberOfRunningExecutions",
                },
                {
                    id: "NumberOfSucceededExecutions",
                },
                {
                    id: "NumberOfFailedExecutions",
                },
                {
                    id: "Actions",
                },
            ]
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "Name",
                width: 300,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "OwnerName",
                width: 200,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Owner",
            },
            {
                id: "Type",
                width: 150,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Type",
            },
            {
                id: "SubType",
                width: 200,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "SubType",
            },
            {
                id: "Status",
                width: 150,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Status",
            },
            {
                id: "NumberOfRunningExecutions",
                width: 150,
                cellRenderer: "Running Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Running",
            },
            {
                id: "NumberOfSucceededExecutions",
                width: 150,
                cellRenderer: "Success Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Succeeded",
            },
            {
                id: "NumberOfFailedExecutions",
                width: 150,
                cellRenderer: "Failure Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Failed",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "DESC",
                    "SortAttribute": "Name",
                    "DisplayName": "Name",
                }]
            }
        ],
    };
}

export default ETLJobTableApplet;
